var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.691 27.5267C32.117 26.5611 32.3551 25.4865 32.3551 25.0029C32.3551 20.8115 29.0986 17.4131 25.0822 17.4131C21.066 17.4131 17.8096 20.8115 17.8096 25.0029C17.8096 29.1942 21.446 31.944 25.0822 31.944C27.4083 31.944 29.4786 30.8063 30.8067 29.0349C31.1547 28.5717 31.4531 28.0658 31.691 27.5267ZM25.0822 28.1492C25.9913 28.1492 26.8224 27.8008 27.4615 27.2245C28.2322 26.5297 28.5715 25.5013 28.5715 25.0029C28.5715 22.9072 27.0922 21.2079 25.0822 21.2079C23.0724 21.2079 21.4286 22.9043 21.4286 25.0001C21.4286 26.4472 23.0724 28.1492 25.0822 28.1492Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95063 25.4863C1.97904 25.5233 1.92222 25.4511 1.95063 25.4863C1.72835 25.1822 1.73394 24.8206 1.95163 24.5129C1.96758 24.4904 1.98383 24.467 2.00029 24.4431C8.53792 14.8984 16.6452 9.82129 25.0258 9.82129C33.3977 9.82129 41.4977 14.8848 48.0283 24.4102C48.1522 24.5909 48.2147 24.7766 48.2147 24.999C48.2147 25.2322 48.142 25.4283 48.0117 25.6179C41.4829 35.1252 33.3901 40.1784 25.0258 40.1784C16.6238 40.1784 8.49537 35.0772 1.95063 25.4863ZM7.03451 23.8436C6.49703 24.5118 6.49703 25.4859 7.03449 26.1543C12.6329 33.1147 18.9365 36.3836 25.0258 36.3836C31.1152 36.3836 37.4188 33.1147 43.0172 26.1543C43.5547 25.4859 43.5547 24.5118 43.0172 23.8436C37.4188 16.8833 31.1152 13.6162 25.0258 13.6162C18.9365 13.6162 12.6329 16.8833 7.03451 23.8436Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShow);
export default __webpack_public_path__ + "static/media/password-show.19497aebf69f290762c80173e1e08888.svg";
export { ForwardRef as ReactComponent };